import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VWidget',{attrs:{"content-class":"pa-0"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(_vm._s(_vm.$t('labels.compliance')))]},proxy:true},{key:"content",fn:function(){return [_c(VList,{staticClass:"pa-0 ma-0"},[_c(VListItem,[_c(VListItemContent,[_c(VListItemSubtitle,[_vm._v(_vm._s(_vm.$t(`labels.status`)))]),_c(VListItemTitle,[_vm._v(_vm._s(_vm.$t(`labels.${_vm.complianceState}`)))])],1),_c(VListItemAction,[_c('compliance-icon',{attrs:{"deal":_vm.deal,"small":""}})],1)],1)],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }